export default __webpack_public_path__ + "static/media/protection-my-family-icon.cc0fe1ca.svg";